import { Dialog, Transition } from '@headlessui/react';
import { XIcon } from '@heroicons/react/solid';
import { FC, useEffect, useState } from 'react';
import tw, { styled } from 'twin.macro';
import { useForm } from 'react-hook-form';
import CertifyingAuthority from '../../../layout-a/forms/common/Inputs//CertifyingAuthority';
import FirstName from '../../../layout-a/forms/common/Inputs/FirstName';
import LastName from '../../../layout-a/forms/common/Inputs//LastName';
import Email from '../../../layout-a/forms/common/Inputs//Email';
import PhoneNumber from '../../../layout-a/forms/common/Inputs//PhoneNumber';
import Message from '../../../layout-a/forms/common/Inputs//Message';
import Image from 'next/image';
import Collapsible from 'react-collapsible';
import WhatsappUpdatesCheckbox from '../../../layout-a/forms/common/Inputs/WhatsappUpdatesCheckboxUpgrad';
import { MinusIcon, PlusIcon } from '@heroicons/react/solid';
import SelectTag from '../../../layout-a/forms/common/Inputs/Select';
import { IBookYourSeatFormProps } from '../BookYourSeat/interface';
import MCSubmitHandler from '../../submitHandler';
import SuccessPopup from '../../SuccessPopup';
import generateOTP from '../../../../lib/common/otpGenerator';
import MasterClassContainer from '../../container';
import TermsAndCondition from '../../../../components/layout-a/forms/common/Inputs/TermsAndConditionCheckboxUpgrad';
import Spinner from '../../../layout-a/components/common/Spinner';
import { EventData } from '../../../../lib/events/constants';
import MobileVerificationPopUp from '../MobileVerification';
import UpGradSubmitHandler from '../submitHandler';

const CloseButton = tw.button`
  border-transparent outline-none
`;

const Container = tw.div`
    w-full  flex 
`;
const ButtonContainer = tw.div`
absolute
top-0
right-0
pt-3
pr-3
`;
const DialogContainer = tw.div`
fixed
inset-0
bg-black
bg-opacity-25
transition-opacity
`;
const Popup = tw.div`
relative
inline-block
bg-white
rounded-t-[3px] 
md:rounded-xl
px-4
pt-5
pb-[22px]
text-left
overflow-hidden
shadow-xl
transform
transition-all
sm:my-4  sm:p-0
`;

const PopupContainer = tw.div`
flex
md:items-center
items-end
justify-center
min-h-screen
text-center
`;

const BookYourSeatContainer = tw.div`
w-full md:py-6 md:px-10
`;

const DescriptionContainer = tw.div`
  md:text-base md:leading-5 text-[14px] leading-5  text-[#333333] md:mb-[31px] mb-[26px]
`;

const FormContainer = tw.form`
    leading-[22px] text-[#444] text-sm
`;

const ContactUsContent = tw.p` 
font-regular 
text-sm 
leading-[21px] 
text-[#666666]
text-center`;

const VerifyButtonContainer = tw.div`
flex 
justify-center 
items-center 
`;

const UGBookYourSeatForm = ({
  title,
  description,
  setOpen,
  isOpen,
  isOTPVerified,
  sectionName,
  webinarDate,
  webinarEndDate,
  webinarId,
  zoomLink,
  instructor,
  classType,
  program,
}: IBookYourSeatFormProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitted },
    reset,
    setValue,
    getValues,
  } = useForm({
    mode: 'onTouched',
  });
  const inputProps = { register, errors, isSubmitted, setValue, getValues };

  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  //const [showBookYouSeatPopUp, setShowBookYouSeatPopUp] = useState(true);
  const [optionalOpen, setOptionalOpen] = useState<boolean>(false);
  const toggleOptional = () => setOptionalOpen(!optionalOpen);

  const [leadData, setLeadData] = useState(0);

  const [pageURL, setPageURL] = useState('');

  const [buttonStatus, setButtonStatus] = useState<boolean>(false);

  // close
  const close = () => {
    setOpen(false);
    setButtonStatus(false);
  };

  useEffect(() => {
    setPageURL(window.location.href);
  }, []);

  const onSubmit = async (data: any) => {
    setButtonStatus(true);
    const eName = EventData[sectionName.replace('click-register', 'submit')]?.name;
    const eLabel = EventData[sectionName.replace('click-register', 'submit')]?.label;
    const eAction = EventData[sectionName.replace('click-register', 'submit')]?.action;

    const extraData = {
      leadType: 'MASTER_CLASS_APPLY_NOW',
      static_lead_type: 'MASTER_CLASS_APPLY_NOW',
      page: `${pageURL}`,
      action: eAction,
      name: eName,
      label: eLabel,
      program: program,
    };

    const response = await UpGradSubmitHandler(data, extraData, reset);
    if (response) {
      setLeadData(response.response);
      setButtonStatus(false);
      setShowOtpPopup(true);
      setOpen(false);
    }
  };
  return (
    <>
      <div className="absolute ">
        <Transition.Root show={isOpen}>
          <Dialog as="div" className="fixed inset-0 z-[200] overflow-y-auto " onClose={setOpen}>
            <MasterClassContainer>
              <PopupContainer className="flex md:items-center items-end justify-center text-center sm:block sm:p-0">
                <Transition.Child
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Dialog.Overlay>
                    <DialogContainer />
                  </Dialog.Overlay>
                </Transition.Child>

                <Transition.Child
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Popup className={`md:w-[704px] w-full -mb-[6px] md:mb-0 `}>
                    <ButtonContainer className="z-[250]">
                      <CloseButton type="button" onClick={close}>
                        <XIcon className="w-6 hover:text-[#585858]" />
                      </CloseButton>
                    </ButtonContainer>
                    <BookYourSeatContainer className="masterclass-font">
                      <div className=" mb-3 md:mb-4 font-bold text-left text-black  md:text-center  text-xl leading-[26px] md:text-2xl">
                        {title}
                      </div>
                      {description && (
                        <div className=" mb-[26px] sm:mb-0 text-left md:text-center  text-sm leading-[21px] sm:text-base sm:leading-[20px] text-[#333333]">
                          <div dangerouslySetInnerHTML={{ __html: description }}></div>
                        </div>
                      )}
                      <div className="border-t border-[#DDDDDD] hidden md:block mt-5 mb-6"></div>
                      <FormContainer onSubmit={handleSubmit(onSubmit)}>
                        <div className="grid grid-cols-2 md:gap-x-5 md:items-center">
                          {/* Certifying authority */}
                          <CertifyingAuthority {...inputProps} />

                          {/* First name */}
                          <FirstName {...inputProps} fullWidth={true} asterisk={true} />

                          {/* Last name */}
                          <LastName {...inputProps} fullWidth={true} asterisk={true} />
                        </div>

                        <div className="grid md:grid-cols-2 gap-x-5 md:items-center">
                          {/* phone number */}
                          <PhoneNumber {...inputProps} fullWidth={true} asterisk={true} />

                          <SelectTag {...inputProps} />
                        </div>

                        {/* Email */}
                        <div className="grid md:grid-cols-2 gap-x-5 md:items-center">
                          <Email {...inputProps} asterisk={true} fullWidth={true} />
                        </div>

                        {/* Optional */}
                        <div
                          className="w-full flex items-center justify-between mb-5 cursor-pointer"
                          onClick={toggleOptional}
                        >
                          <div className="text-sm leading-[18px] text-[#666666] font-semibold ">
                            Have a doubt? (optional)
                          </div>
                          <div>
                            {optionalOpen ? (
                              <MinusIcon className="w-4 text-[#231f20]" />
                            ) : (
                              <PlusIcon className="w-4 text-black" />
                            )}
                          </div>
                        </div>

                        <Collapsible open={optionalOpen} trigger="" overflowWhenOpen="visible">
                          <div>
                            <div className="relative md:mb-8 mb-[25px] w-full group">
                              <Message {...inputProps} />
                            </div>
                          </div>
                        </Collapsible>

                        {/* Terms and condition checkbox for Europe region / Whatsapp updates checkbox */}

                        <WhatsappUpdatesCheckbox register={register} isWhatsappContent={true} />

                        <TermsAndCondition
                          errors={errors}
                          isSubmitted={isSubmitted}
                          register={register}
                          isWhatsappContent={true}
                        />

                        <VerifyButtonContainer>
                          <button className=" mt-5 flex justify-center items-center px-8 font-bold bg-[#db4144] text-white py-4 text-center md:text-base md:leading-6 text-sm leading-[19px] rounded-[3px] md:rounded">
                            {buttonStatus && <Spinner />}
                            {buttonStatus ? <span className="pl-[2px]">Submitting...</span> : 'Submit'}
                          </button>
                        </VerifyButtonContainer>

                        <ContactUsContent className="mt-6 md:mt-4">
                          Have any further questions? &nbsp;
                          <a
                            className="font-semibold underline"
                            href="mailto:bootcampsupport@upgrad.com"
                            target="_blank"
                            rel="noreferrer noopener"
                          >
                            Contact Us
                          </a>
                        </ContactUsContent>
                      </FormContainer>
                    </BookYourSeatContainer>
                  </Popup>
                </Transition.Child>
              </PopupContainer>
            </MasterClassContainer>
          </Dialog>
        </Transition.Root>
      </div>

      {showOtpPopup && (
        <MobileVerificationPopUp
          title={'Mobile Verification'}
          isOpen={showOtpPopup}
          setOpen={setShowOtpPopup}
          leadData={leadData}
          sectionName={sectionName}
          setShowSuccessPopup={setShowSuccessPopup}
          setShowBookYouSeatPopUp={setOpen}
          webinarDate={webinarDate}
          webinarEndDate={webinarEndDate}
          webinarId={webinarId}
          zoomLink={zoomLink}
          instructor={instructor}
          classType={classType}
        />
      )}

      {showSuccessPopup && (
        <SuccessPopup
          contentSelected={true}
          isOpen={showSuccessPopup}
          setOpen={setShowSuccessPopup}
          sectionName={sectionName}
        />
      )}
    </>
  );
};

export default UGBookYourSeatForm;
